const NAMESPACE = 'Business Units Lib';
const EVENT_NAME = 'Select Changed';
export function createBusinessUnitSelectChangeTracker(trackerInstance) {
  const newTracker = trackerInstance.clone({
    standalone: true,
    preserveTrackerEvents: false,
    preserveTrackerProperties: false
  });
  return properties => {
    newTracker.track(NAMESPACE, EVENT_NAME, properties);
  };
}